module.exports = __webpack_public_path__ + "static/media/close-icon.2c5552a1.svg";